import { createReactMounter } from "./lib/react_mounter.jsx";
import ScoreboardShow from "./components/ScoreboardShow.jsx";
import ScoreboardIndex from "./components/ScoreboardIndex.jsx";

const COMPONENTS = {
  ScoreboardShow,
  ScoreboardIndex,
};

const mounter = createReactMounter(COMPONENTS);
mounter.initializeApp();